import SessionAvailabilityPill from './SessionAvailabilityPill';

export default SessionAvailabilityPill;
